module.exports = __webpack_public_path__ + "img/CABALLETES.8c3eb2e2.png";